export default function ArcheryDuelIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M33 4c-9.5 0-15 7.4-15 15.2 0 9.2 8.4 15.6 15 18.8 6.6-3.2 15-9.6 15-18.8C48 11.4 42.5 4 33 4z" fill="#FF8A1F" />
      <path d="M33 38l-3.4 5h6.8z" fill="#E06E00" />
      <ellipse cx="26.5" cy="13.5" rx="3.2" ry="5.6" transform="rotate(-28 26.5 13.5)" fill="#FFFFFF" fillOpacity="0.7" />
      <path d="M33 43c-3 5 3 8 0 14" stroke="#FFFFFF" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <path d="M8 58C6 40 14 26 26 20" stroke="#8A4F22" strokeWidth="4.5" fill="none" strokeLinecap="round" />
      <path d="M8 58L26 20" stroke="#F4F1E8" strokeWidth="1.4" />
      <path d="M12 46L44 26" stroke="#E2B26A" strokeWidth="3.4" strokeLinecap="round" />
      <path d="M41 22l9 1-5 8z" fill="#C9D3DE" />
      <path d="M12 46l-6-1 3 4-1 5 6-4z" fill="#2F8BFF" />
      <path d="M48 12l2 4 4 1-4 1-2 4-2-4-4-1 4-1z" fill="#FFE14D" />
      <path d="M54 30l1.2 2.4 2.4.6-2.4.6L54 36l-1.2-2.4-2.4-.6 2.4-.6z" fill="#FFE14D" />
    </svg>
  );
}
